import React from 'react';
import { connect } from 'react-redux';
// import FontIcon from 'react-toolbox/lib/font_icon';
import { get } from '~/actions/containers';
import Tag from '~/components/Tag';
import Title from '~/components/Title';
import style from './style.scss';

class Container extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  componentDidMount() {
    this.load();
  }

  load() {
    if (!this.props.id || !this.props.item) {
      this.setState({ loading: true });
      return;
    }

    get(this.props.dispatch, this.context.apiClient, this.props.id)
      .then(() => this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  renderItem() {
    const container = this.props.item.toJS();
    return (
      <div onClick={() => this.context.dialogPush('container', { id: container.id })}>
        <div>
          <Tag type="location" id={container.locationId} style={{ float: 'right' }} />
          <div style={{ display: 'inline-block' }}>
            <Title>
              # {container.sku}
            </Title>
          </div>
        </div>
        <div>Articles:<span style={{ float: 'right' }}>{this.props.articleCount}</span></div>
        {container.removed && <div className={style.removed}>REMOVED</div>}
      </div>
    );
  }

  render() {
    const { id, item, className, dispatch, articleCount, tasks, ...props } = this.props;
    return (
      <div className={[style.container, className].join(' ')} {...props}>
        <div className={style.content}>
          {this.state.loading && 'Loading'}
          {!this.state.loading && !item && '404'}
          {!this.state.loading && item && this.renderItem()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  item: state.getIn(['containers', 'items', props.id]),
  articleCount: state.getIn(['stock', 'items'])
    .filter(i => i.getIn(['location', 'id']) === props.id)
    .reduce((s, v) => s + v.get('count'), 0),
});

export default connect(mapStateToProps)(Container);



// WEBPACK FOOTER //
// ./app/components/Container/index.js